<template>
  <div>
    <div class="mb-0">
      <b-row class="match-height mb-0">
        <b-col
          cols="12"
          md="4"
        >
          <b-card
            title="Provider contact details:"
          >
            <b-card-text>
              <div
                v-for="(field, index) in providerInformation.contact.Show"
                :key="index"
              >
                <strong>{{ field }}: </strong>
                <span v-if="isLink.includes(field)">
                  <a
                    :href="providerInformation.contact[field]"
                    target="_blank"
                  >{{ providerInformation.name }} {{ field.toLowerCase() }}</a>
                </span>
                <span
                  v-else
                >
                  {{ providerInformation.contact[field] }}
                </span>

              </div>
            </b-card-text>
          </b-card>

          <b-card
            v-if="providerInformation.reportDisplay.status"
            title="Other current products from this provider"
          >
            <b-card-text>
              <div>
                <span v-if="Number(providerInformation.reportDisplay.nextcount) === 1">
                  <strong>Next: </strong>
                  <router-link :to="`/product/report/${providerInformation.reportDisplay.nextR}`">{{ providerInformation.reportDisplay.next }}</router-link>
                  <br>
                </span>
                <br>
                <span>
                  <router-link :to="{ name: 'current-products', params: { category: 'providers', value: providerInformation.reportDisplay.provider }}">{{ (providerInformation.reportDisplay.count > 2 ? 'All ' : '') + providerInformation.reportDisplay.count + ' products from ' + providerInformation.reportDisplay.provider }}</router-link>
                </span>
              </div>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col
          cols="12"
          md="8"
        >
          <div v-if="reportFlavour === 'draft'">
            <draft-blocking-overlay />
          </div>
          <div v-else-if="reportFlavour === 'bespoke'">
            <bespoke-blocking-overlay />
          </div>
          <b-card
            v-else-if="isPremium"
            title="Investment Enquiry"
            class="h-100"
          >
            <b-card-text>
              Contact the provider directly about this product
            </b-card-text>
            <b-form @submit.prevent="submitEnquiry">
              <b-row>
                <b-col cols="6">
                  <b-form-group label="Provider">
                    <b-form-input v-model="enquiryForm.provider" readonly />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Product Name">
                    <b-form-input v-model="enquiryForm.productName" readonly />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="6">
                  <b-form-group label="Name">
                    <b-form-input v-model="enquiryForm.name" :readonly="userDataLoaded" />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Company">
                    <b-form-input v-model="enquiryForm.company" :readonly="userDataLoaded" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="6">
                  <b-form-group label="Email Address">
                    <b-form-input v-model="enquiryForm.email" type="email" :readonly="userDataLoaded" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-form-group label="Message">
                <b-form-textarea v-model="enquiryForm.message" rows="3" placeholder="Enter your message here..." />
              </b-form-group>
              <div class="text-right">
                <b-button variant="primary" type="submit" :disabled="loading">
                  <b-spinner v-if="loading" small />
                  <span v-else>Submit</span>
                </b-button>
              </div>
            </b-form>
          </b-card>
          <div v-else>
            <UpgradeToPremium />
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BCardText, BForm, BFormGroup, BFormInput, BFormTextarea, BButton, BSpinner,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import UpgradeToPremium from '@/views/components/UpgradeToPremium.vue'
import DraftBlockingOverlay from '@/views/components/DraftBlockingOverlay.vue'
import BespokeBlockingOverlay from '@/views/components/BespokeBlockingOverlay.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BSpinner,
    UpgradeToPremium,
    DraftBlockingOverlay,
    BespokeBlockingOverlay,
  },
  props: {
    providerInformation: {
      type: Object,
      default: () => ({
        contact: {},
        reportDisplay: {},
        name: '',
        providerId: '',
      }),
    },
    documents: {
      type: Object,
      default: () => ({}),
    },
    reportTitle: {
      type: String,
      default: '',
    },
    detailsId: {
      type: [String, Number],
      default: '',
    },
    reportFlavour: {
      type: String,
      default: 'standard',
    },
  },
  data() {
    return {
      isLink: ['Platform', 'Website'],
      baseURL: process.env.VUE_APP_BACKEND_PATH,
      enquiryForm: {
        provider: '',
        productName: '',
        name: '',
        company: '',
        email: '',
        message: '',
      },
      userDataLoaded: false,
      userId: '',
      loading: false,
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isLoggedIn',
      'isPremium',
    ]),
  },
  watch: {
    isLoggedIn: {
      immediate: true,
      handler(isLoggedIn) {
        if (isLoggedIn) this.loadUserData()
      },
    },
    'providerInformation.name': {
      immediate: true,
      handler(val) {
        if (val) {
          this.enquiryForm.provider = val
        }
      },
    },
    reportTitle: {
      immediate: true,
      handler(val) {
        if (val) {
          this.enquiryForm.productName = val
        }
      },
    },
  },
  methods: {
    loadUserData() {
      this.$http
        .get('account.cfc', {
          params: {
            method: 'getUserLogin',
          },
        })
        .then(response => {
          if (response.data.success && response.data.data) {
            this.enquiryForm.name = response.data.data.fullName || ''
            this.enquiryForm.company = response.data.data.companyName || ''
            this.enquiryForm.email = response.data.data.email || ''
            this.userDataLoaded = true
          }
        })
        .catch(error => {
          console.error('Error loading user data:', error)
        })
    },
    submitEnquiry() {
      if (this.enquiryForm.message.length < 10) {
        this.$bvToast.toast('Message is too short. Please enter at least 10 characters.', {
          title: 'Validation Error',
          variant: 'warning',
          solid: true,
        })
        return
      }

      this.loading = true

      const submittedForm = {
        fvcdetailsid: this.detailsId,
        provideremail: this.providerInformation.contact.Email || '',
        productname: this.enquiryForm.productName,
        name: this.enquiryForm.name,
        company: this.enquiryForm.company,
        email: this.enquiryForm.email,
        message: this.enquiryForm.message,
        providerId: this.providerInformation.providerId,
      }

      this.$http
        .get('research.cfc', {
          params: {
            method: 'sendProviderEnquiry',
            submittedForm,
          },
        })
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.enquiryForm.message = ''
            this.$bvToast.toast('Your enquiry has been sent to the provider', {
              title: 'Success',
              variant: 'success',
              solid: true,
            })
          } else {
            this.$bvToast.toast('Your enquiry could not be sent. Please try again', {
              title: 'Failed',
              variant: 'danger',
              solid: true,
            })
          }
        })
        .catch(error => {
          console.log('Error:', error)
          this.loading = false
          this.$bvToast.toast('Your enquiry could not be sent. Please try again', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.header-card {
  margin-bottom: calc(2rem + 1px) !important;
}
</style>
